<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part">
<h2><span class="h2-inner">Part One</span></h2>
<p class="firstInSection"><br/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?01bd90db